import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect, Link, NavLink, withRouter } from "react-router-dom";

import EntryView from './components/EntryView';
import SendForm from './components/SendForm';
import SearchOverlay from './components/SearchOverlay';
import FlokkarList from './components/FlokkarList';
import PageMenu from './components/PageMenu';
import PageView from './components/PageView';

import config from './config';
import SearchResultsList from './components/SearchResultsList';

import logo from './images/sam-logo.png';
import MatomoVeftalning from './components/MatomoVeftalning';

window.EventBus = require('eventbusjs');

class App extends Component {
	constructor(props) {
		super(props);

		this.dataSendHandler = this.dataSendHandler.bind(this);
		this.headerClickHandler = this.headerClickHandler.bind(this);
		this.menuButtonClickHandler = this.menuButtonClickHandler.bind(this);

		this.state = {
			searchOverlayVisible: false,
			menuOpen: false
		};
	}

	componentDidMount() {
		// Undirbúum grecaptcha

		// Skilgreinum fall sem kallað er á þegar svör berast frá Google reCaptcha API
		window.grecaptchaCallback = this.grecaptchaCallback.bind(this);

		// Frumstillum reCaptcha til að sjá til þess að virknin verði til staðar síðar meir
		this.initializeReCaptcha();

		// Skráum fall fyrir viðburð data.send sem EntryView og SendForm senda þegar þau ætla að senda frá sér gögn (nýtt nýyrði, voting eða athugasemd)
		window.EventBus.addEventListener('data.send', this.dataSendHandler);

		// Hér hlustum við eftir breytingu á route og lokum valmynd í farsíma ef slóðin breytist
		this.refs.router.history.listen(function() {
			this.setState({
				menuOpen: false
			});
		}.bind(this));
	}

	headerClickHandler(event) {
		if (event.target.tagName.toLowerCase() == 'a') {
			this.setState({
				menuOpen: false
			});
		}
	}

	menuButtonClickHandler(event) {
		if (!this.state.menuOpen) {
			this.refs.menuContent.scrollTop = 0;
		}

		this.setState({
			menuOpen: !this.state.menuOpen
		});
	}

	// Fall sem keyrir þegar EntryView og SendForm ætla að senda frá sér gögn
	dataSendHandler(event) {
		// Skráum upplýsingar um gögnin í window._nyaction til að geta nálgast þær þegar grecaptcha hefur fengið svar frá vefþjóni Google
		window._nyaction = event.target;

		// Keyrum grecaptcha
		window.grecaptcha.execute();
	}

	initializeReCaptcha() {
		if (window.reCaptchaInitialized) {
			return;
		}

		let grcInit = function() {
			try {
				if (window.grecaptcha) {
					window.grecaptcha.render('grecaptcha', {
						callback: window.grecaptchaCallback
					});

					window.reCaptchaInitialized = true;
				}
			}
			catch (e) {
				setTimeout(grcInit, 500);
			}
		}.bind(this);

		grcInit();
	}

	// Hér tökum við við svari frá grecaptcha API (Google)
	grecaptchaCallback(event) {
		// Hér er athugað hvaða gögn eigi að senda, það er skráð í window._nyaction
		if (window._nyaction.type == 'upvote' || window._nyaction.type == 'downvote') {
			this.sendVote(event);
		}
		if (window._nyaction.type == 'sendcomment') {
			this.sendComment(event);
		}
		if (window._nyaction.type == 'sendform') {
			this.sendFormData(event);
		}

		// Keyrum .reset til að hægt sé að nota grecaptcha tilvikið aftur
		window.grecaptcha.reset()
	}

	// Sendir einkunn til API
	sendVote(grecaptchaResponse) {
		if (!window._nyaction) {
			return;
		}

		// Setur öll gildi í FormData hlut
		let formDataValues = new FormData();

		formDataValues.append('recaptcha', grecaptchaResponse);
		formDataValues.append('id', window._nyaction.id);

		// Athugum hvort þessi vafri hafi áður sent einkunn
		let sendOppositeVote = false;
		if (localStorage) {
			if (window._nyaction.type == 'upvote' && localStorage.getItem('downvote-'+window._nyaction.id)) {
				formDataValues.append('oppositevote', true);
			}

			if (window._nyaction.type == 'downvote' && localStorage.getItem('upvote-'+window._nyaction.id)) {
				formDataValues.append('oppositevote', true);
			}
		}

		// Kallar á API
		fetch(config.apiRoot+'/api/'+window._nyaction.type+'/', {
			method: 'post',
			body: formDataValues
		})
		.then(function(response) {

			return response.json();
		}.bind(this))
		.then(function(json) {
			if (json.updated) {
				// Setjum gildi í localStorage um að þessi vafri hafi áður sent einkunn
				if (localStorage) {
					if (window._nyaction.type == 'upvote' && localStorage.getItem('downvote-'+window._nyaction.id)) {
						console.log('remove current downvote')
						localStorage.removeItem('downvote-'+window._nyaction.id);
					}

					if (window._nyaction.type == 'downvote' && localStorage.getItem('upvote-'+window._nyaction.id)) {
						console.log('remove current upvote')
						localStorage.removeItem('upvote-'+window._nyaction.id);
					}

					localStorage.setItem(window._nyaction.type+'-'+window._nyaction.id, true);
				}

				// Sendir event til EntryView um að einkunnargjöf hafi heppnast, þar uppfærist talan í tökkunum
				window.EventBus.dispatch('success.voting', {
					upvotes: json.upvotes,
					downvotes: json.downvotes,
					skyring: window._nyaction.id
				});
			}
			window._nyaction = null;
		}.bind(this));
	}

	// Sendir athugasemd til API
	sendComment(grecaptchaResponse) {
		let formDataValues = new FormData();

		for (var key in window._nyaction.comment) {
		    formDataValues.append(key, window._nyaction.comment[key]);
		}

		formDataValues.append('recaptcha', grecaptchaResponse);
		formDataValues.append('nyyrdi', window._nyaction.id)

		fetch(config.apiRoot+'/api/athugasemdir/', {
			method: 'post',
			body: formDataValues
		})
		.then(function(response) {
			return response.json();
		}.bind(this))
		.then(function(json) {
			if (json.success) {
				window.EventBus.dispatch('success.sendcomment', {
					skyring: window._nyaction.id,
					comment: json.comment
				});
			}
			window._nyaction = null;
		}.bind(this));
	}

	sendFormData(grecaptchaResponse) {
		let formDataValues = new FormData();

		// Dagsetningum þarf að snúa við til að Django skilji þær
		if (window._nyaction.data.dagsetning && window._nyaction.data.dagsetning != '') {
			window._nyaction.data.dagsetning = window._nyaction.data.dagsetning.split('-').reverse().join('-');
		}

		for (var key in window._nyaction.data) {
		    formDataValues.append(key, window._nyaction.data[key]);
		}

		formDataValues.append('recaptcha', grecaptchaResponse);

		fetch(config.apiRoot+'/api/nyyrdi/', {
			method: 'post',
			body: formDataValues
		})
		.then(function(response) {
			return response.json();
		})
		.then(function(json) {
			if (json.success) {
				window.EventBus.dispatch('success.sendcomment');
			}
		}.bind(this));
	}

	render() {
		return (
			<BrowserRouter ref="router">
				<div className="container-fluid app-container">
					<div className="row no-gutters">

						<div className={'col-12 col-lg-6 col-xl-4 header-column'+(this.state.menuOpen ? ' open' : '')}>

							<button className="mobile-menu-button" onClick={this.menuButtonClickHandler}>
								<span className="icon-middle" />
								<span className="icon-before-after" />
							</button>

							<div className="column-content" ref="menuContent">

								<a title="Stofnun Árna Magnússonar í íslenskum fræðum" href="http://arnastofnun.is"><img src={logo} className="logo" /></a>

								<header>

									<div className="app-title-container">
										<h1 className="app-title"><Link to="/">Nýyrði</Link></h1>
									</div>

									<p className="subtitle">
										<span>Nýyrðavefur Stofnunar Árna Magnússonar í íslenskum fræðum</span>
									</p>

								</header>

								<NavLink to="/sendu/" className="main-link"><span>Sendu okkur nýyrði</span></NavLink>

								<h2><span>Röðun</span></h2>

								<div className="menu">
									<Link to="/leit/">Nýjast</Link>
									<NavLink to="/leit//rodun/stafrof">Stafrófsröð</NavLink>
									<NavLink to="/leit//rodun/vinsaelast">Vinsælast</NavLink>
									{/*<NavLink to="/leit//rodun/ovinsaelast">Óvinsælast</NavLink>*/}
									<NavLink to="/leit//rodun/umtal">Mest umtal</NavLink>
									<NavLink to="/leit//rodun/handahof">Handahóf</NavLink>
								</div>

								<h2><span>Flokkar</span></h2>

								<FlokkarList />

								<div className="page-links">
									<PageMenu />
								</div>

							</div>

						</div>

						<div className="col-12 col-lg-6 col-xl-8">
							<div className="column-content">

								<Route exact path="/" render={(routeProps) => (
									<SearchResultsList {...routeProps} />
								)} />

								<Route exact strict 
									path="(/leit/)?:searchString*(/flokkur/)?:flokkur*(/rodun/)?:order*(/sida/)?:page*" 
									render={(routeProps) => (
									<SearchResultsList {...routeProps} />
								)} />

								<Route exact strict path="/nyyrdi/:nyyrdi" render={(routeProps) => (
									<EntryView singleItem={true} {...routeProps} />
								)} />

								<Route exact path="/sendu" render={(routeProps) => (
									<SendForm />
								)} />

								<Route exact strict path="/sendu/takk" render={(routeProps) => (
									<SendForm takk={true} />
								)} />

								<Route exact strict path="/s/:sida" render={(routeProps) => (
									<PageView {...routeProps} />
								)} />

							</div>

						</div>

					</div>

					<div className="mobile-header">
						<h1>Nýyrði</h1>
					</div>

					<div className="toolbar">

						<NavLink className="icon-send" to="/sendu" onClick={function() {
							this.setState({
								searchOverlayVisible: false
							})
						}.bind(this)}></NavLink>

						<button className="icon-search" onClick={function() {
							this.setState({
								searchOverlayVisible: !this.state.searchOverlayVisible
							})
						}.bind(this)}></button>

					</div>

					<SearchOverlay visible={this.state.searchOverlayVisible} onSearch={function() {
						this.setState({
							searchOverlayVisible: false
						});
					}.bind(this)} onClose={function() {
						this.setState({
							searchOverlayVisible: false
						});
					}.bind(this)} />

					<div id="grecaptcha" 
						className="g-recaptcha" 
						data-sitekey={config.grecaptchaKey}
						data-size="invisible"></div>
					
					<MatomoVeftalning />
				</div>
			</BrowserRouter>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js